import type { Cart, ICartPlugin } from '../../types'
import CartPlugin from '../CartPlugin'

import {
  UnderwearCareBagPluginOptions,
  UnderwearCareBagProduct,
  ProductImage,
} from './types'

export class UnderwearCareBagPlugin extends CartPlugin implements ICartPlugin {
  private productId: number
  private variantId: number
  private productPrice: number
  private productTitle: string
  private productImage: ProductImage
  constructor({
    productId,
    variantId,
    productPrice,
    productTitle,
    productImage,
    enabled,
  }: UnderwearCareBagPluginOptions) {
    super(
      Boolean(
        enabled &&
          typeof productId !== 'undefined' &&
          typeof variantId !== 'undefined' &&
          typeof productPrice !== 'undefined',
      ),
    )
    this.productId = productId!
    this.variantId = variantId!
    this.productPrice = productPrice!
    this.productTitle = productTitle!
    this.productImage = productImage!
  }

  setUnderwearCareBag = (enabled: boolean): Promise<Cart> =>
    this.manager.update({
      updates: { [this.variantId]: enabled ? 1 : 0 },
    })

  addUnderwearCareBag = (): Promise<Cart> =>
    this.manager.addItem({
      id: this.variantId,
      quantity: 1,
    })

  removeUnderwearCareBag = (): Promise<Cart> =>
    this.manager.removeItem(this.variantId)

  onClear = (cart: Readonly<Cart>): Cart => {
    cart.meta.underwearCareBag = false
    return cart
  }

  getProduct = (): UnderwearCareBagProduct => ({
    id: this.productId,
    title: this.productTitle,
    price: this.productPrice,
    image: this.productImage,
  })

  getPrice = (): number => this.productPrice

  onFormatCart = (cart: Cart): Cart => {
    const newCart = { ...cart }
    newCart.meta.underwearCareBag = Boolean(
      newCart.items.find(({ productId }) => productId === this.productId),
    )

    return newCart
  }
}
